<script setup lang="ts">
import { z } from 'zod'
import type { FormSubmitEvent } from '#ui/types'

const props = defineProps<{ parentId: string, id?: string }>()

const emit = defineEmits(['created', 'updated'])
const toast = useToast()
const review = ref({ review: '' })

const pb = useNuxtApp().$pb
const addingReview = ref(false)
type ReviewSchema = z.output<typeof reviewSchema>
const reviewSchema = z.object({
  id: z.string().optional(),
  review: z.string().min(3, 'Review is required'),
})
const { displayError } = useSubmitError()
async function submitReview(event: FormSubmitEvent<ReviewSchema>) {
  const res = { ...event.data, parent: props.parentId }
  addingReview.value = true
  toast.add({
    id: 'saving-review',
    title: 'Review Saving...',
    icon: 'ri:loader-5-fill',
  })

  try {
    if (!props.id) {
      const saved = await pb.collection('reviews').create(res)
      emit('created', saved)
    }
    else {
      const updated = await pb.collection('reviews').update(props.id, res)
      emit('updated', updated)
    }
    toast.remove('saving-review')
    toast.add({
      title: 'Review Saved...',
      icon: 'ri:check-line',
    })
    addingReview.value = false
  }
  catch (err) {
    toast.remove('saving-review')
    displayError(err)
  }
}
</script>

<template>
  <UForm
    :state="review"
    :schema="reviewSchema"
    @submit="submitReview"
  >
    <UFormGroup
      name="review"
      label="Reply"
    >
      <UTextarea
        v-model="review.review"
        placeholder="Enter your reply here..."
      />
    </UFormGroup>
    <div class="flex justify-end mt-3">
      <ButtonSave
        type="submit"
        :disabled="addingReview"
        label="Post"
        size="xl"
      />
    </div>
  </UForm>
</template>
